export const SINGLE_COLUMN_BREAKPOINT_PX = 1151;
export const NAV_COLLAPSE_BREAKPOINT_PX = 819;
